import styled from 'styled-components';
import { typographyStyle } from '../styled.js';
import { margin } from '../../../v2/foundation/spacing/utils.js';

/* eslint-disable import/prefer-default-export */
var StyledParagraph = styled.p.withConfig({
  displayName: "StyledParagraph",
  componentId: "sc-vr3r2m-0"
})(["", " ", ""], typographyStyle, function (_ref) {
  var $noMargin = _ref.$noMargin;
  return $noMargin ? margin(0) : margin(0, 0, 3);
});

export { StyledParagraph };
